module.exports = __webpack_public_path__ + "static/img/12.c5d5b8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/12.png
// module id = xdXn
// module chunks = 0